import { render, staticRenderFns } from "./UEditorRichText.vue?vue&type=template&id=0c27e594"
import script from "./UEditorRichText.vue?vue&type=script&lang=js"
export * from "./UEditorRichText.vue?vue&type=script&lang=js"
import style0 from "./UEditorRichText.vue?vue&type=style&index=0&id=0c27e594&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports